import React from 'react';

const Tag = ({ children }) => (
  <span className="inline-block bg-blue-100 text-blue-800 px-2 py-1 rounded text-sm mr-2 mb-2">
    {children}
  </span>
);

export default Tag;